module.exports = __webpack_public_path__ + "img/banner.111d51e6.png";